import { IconName } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import { conditionalScaleAnimation } from 'libs/styles/animations';
import { EColors, EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    name?: string;
    img?: string;
    icon?: IconName;
    color?: string;
    selected?: boolean;
    onSelected?: () => void;
    small?: boolean;
    className?: string;
}

export const MinuteStyle = (props: Props): JSX.Element => {
    return (
        <S_MinuteStyle
            className={props.className}
            onClick={props.onSelected}
            {...conditionalScaleAnimation(true, 1.05, 0.9)}
        >
            {props.img && <S_Image $img={props.img} $small={props.small} />}
            {props.icon && (
                <S_IconBg>
                    <S_Icon icon={['fal', props.icon]} />
                </S_IconBg>
            )}
            {props.color && <S_Color $small={props.small} $color={props.color} />}
            {props.name && <S_Title>{props.name}</S_Title>}
            {props.selected && (
                <S_Selected>
                    <S_Checked icon={['fas', 'circle-check']} />
                </S_Selected>
            )}
        </S_MinuteStyle>
    );
};

const S_MinuteStyle = styled(motion.div)`
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    position: relative;
`;

const S_Image = styled.div<{
    $img: string;
    $small?: boolean;
}>`
    width: ${(props) => (props.$small ? '58px' : '100px')};
    height: ${(props) => (props.$small ? '58px' : '100px')};
    border-radius: 7px;
    background-image: url(${(props) => props.$img});
    background-size: cover;
    border: 1px solid #bebebe;
`;

const S_Title = styled.div`
    color: ${EColors.DARK};
    font-size: 15px;
    font-family: ${EFonts.Regular};
    margin: 10px 0 0 0;
`;

const S_Selected = styled.div`
    position: absolute;
    top: -5px;
    right: -5px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid white;
    background-color: white;
`;

const S_Checked = styled(FontAwesomeIcon)`
    font-size: 26px;
    path {
        fill: url(#acc2Gradient);
    }
`;

const S_IconBg = styled.div`
    width: 100px;
    height: 100px;
    border-radius: 7px;
    background-color: #e5e5e5;
    border: 1px solid #bebebe;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const S_Icon = styled(FontAwesomeIcon)`
    font-size: 20px;
    color: ${EColors.DARK};
`;

const S_Color = styled.div<{
    $color: string;
    $small?: boolean;
}>`
    width: ${(props) => (props.$small ? '58px' : '100px')};
    height: ${(props) => (props.$small ? '58px' : '100px')};
    border-radius: 7px;
    background-color: ${(props) => props.$color};
    border: 1px solid #bebebe;
`;
